import React from 'react';
import PropTypes from 'prop-types';

import InputWrapper from '../InputWrapper';
import InputLabel from '../InputLabel';
import Input from '../Input';

const ToggleSwitch = ({
  id,
  isChecked,
  isDisabled,
  isRequired,
  label,
  name,
  onBlur,
  onChange,
  toggleSwitchWrapperProps,
  inputLabelProps,
  inputProps
}) => (
  <InputWrapper disableInputStyle {...toggleSwitchWrapperProps}>
    <InputLabel
      isRequired={isRequired}
      htmlFor={id || name}
      className='input__switch-label flex-row'
      {...inputLabelProps}
    >
      <Input
        id={id || name}
        type='checkbox'
        disableControlClass
        className='input__switch'
        onChange={onChange}
        onBlur={onBlur}
        checked={isChecked}
        required={isRequired}
        disabled={isDisabled}
        {...inputProps}
      />
      <div className='input__switch-btn mr-1x' htmlFor={id || name} />
      {label}
    </InputLabel>
  </InputWrapper>
);

ToggleSwitch.defaultProps = {
  isChecked: false,
  isRequired: false,
  isDisabled: false
};

ToggleSwitch.propTypes = {
  /* Required */
  name: PropTypes.string.isRequired,
  /* Regular */
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.node,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  /* Component */
  toggleSwitchWrapperProps: PropTypes.object,
  inputLabelProps: PropTypes.object,
  inputProps: PropTypes.object
};

export default ToggleSwitch;
